<div class="wrap" fxLayout="column">
    <div fxFlex="40px" fxLayout="row" class="mb-2">
        <div fxFlex="60%">
            <h2 class="title-page-global custom-title">{{this.subjectName}}  {{this.gradeName ? ' - ' + this.gradeName : ''}}</h2>
        </div>
        <div fxFlex="40%" fxLayout="row" fxLayoutAlign="end none" style="padding-bottom: 10px">
            <button fxFlex="180px" class="btn btn-add-global btn-add" (click)="editLink()">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.49509 2.50304C5.49503 2.19997 5.25214 1.95324 4.95119 1.95324H2.9756C1.85622 1.95324 0.95 2.87154 0.95 4.00237V10.0003C0.95 11.1317 1.85621 12.05 2.9756 12.05H8.90239C10.0218 12.05 10.9285 11.1317 10.9285 10.0003V8.00173C10.9285 7.6981 10.6857 7.45126 10.3846 7.45126C10.0836 7.45126 9.84074 7.69806 9.84074 8.00118V10.0003C9.84074 10.5254 9.41984 10.9502 8.90239 10.9502H2.9756C2.45818 10.9502 2.0378 10.5254 2.0378 10.0003V4.00237C2.0378 3.47781 2.45817 3.05308 2.9756 3.05308L4.95119 3.05308L4.95147 3.05308C5.02331 3.05268 5.09436 3.03813 5.16057 3.01025C5.22678 2.98238 5.28685 2.94173 5.33734 2.89062C5.38783 2.83952 5.42775 2.77897 5.45482 2.71242C5.48186 2.64595 5.49554 2.5748 5.49509 2.50304ZM5.49509 2.50304C5.49509 2.50297 5.49509 2.5029 5.49509 2.50282L5.44509 2.50316H5.49509C5.49509 2.50312 5.49509 2.50308 5.49509 2.50304ZM5.08815 8.63047L4.21881 8.88124L4.47602 7.97882L10.2832 2.10224C10.2832 2.10223 10.2832 2.10221 10.2832 2.1022C10.3013 2.08396 10.3229 2.06951 10.3466 2.05968C10.3704 2.04985 10.3959 2.04485 10.4216 2.04497C10.4473 2.04509 10.4727 2.05033 10.4964 2.06039C10.5201 2.07045 10.5415 2.08512 10.5595 2.10355L10.5597 2.10384L10.909 2.45692L10.9091 2.45702C10.9463 2.49441 10.9672 2.54492 10.9675 2.59765C10.9677 2.65033 10.9473 2.70099 10.9105 2.73872C10.9105 2.73875 10.9104 2.73878 10.9104 2.73882L5.08815 8.63047ZM5.64923 9.61004L5.66178 9.60643L5.67096 9.59714L11.6802 3.5156C11.6802 3.5156 11.6802 3.5156 11.6803 3.51559C12.1772 3.01289 12.1721 2.19455 11.6715 1.68762L11.3225 1.33425C11.3224 1.33421 11.3224 1.33418 11.3224 1.33414C11.205 1.21361 11.0648 1.117 10.9098 1.05111C10.7549 0.985235 10.5884 0.950869 10.42 0.950016C10.2516 0.949164 10.0848 0.981841 9.92919 1.04614C9.77359 1.11044 9.63235 1.20508 9.51371 1.32454L9.51362 1.32463L3.52028 7.39022L3.51128 7.39934L3.50776 7.41166L2.90551 9.52353L2.90549 9.52361C2.87717 9.62353 2.87755 9.7294 2.90658 9.82911C2.94581 9.96816 3.03861 10.086 3.16462 10.1567C3.29062 10.2274 3.43953 10.2453 3.57867 10.2063L3.57903 10.2062L5.64923 9.61004Z" fill="white" stroke="white" stroke-width="0.1"/>
                    </svg>                    
                Chỉnh sửa
            </button>
        </div>
    </div>
    <div class="bg-content-global custom-bg-content-global">
        <div fxLayout="row" fxLayoutAlign="start center" class="col-sm-12 mb-4 title-tab">
            <button class="title__education-lv1-custom {{ active_tab === 'content' ? 'active' : '' }}" mat-raised-button (click)="clickTab('content')">Nội dung</button>
            <button class="title__education-lv1-custom {{ active_tab === 'required' ? 'active' : '' }}  mr-1" mat-raised-button (click)="clickTab('required');">Yêu cầu cần đạt</button>
        </div>
        
        <div class="content">
            <!-- tab yeu cau -->
            <div class="tree tree--tab1" *ngIf="active_tab == 'required'">
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-nested-tree-node *matTreeNodeDef="let node" class="con">
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <li class="example-tree-container">
                            <div class="mat-tree-node">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 node-tree" style="padding-left: 32px !important" style="white-space: pre-line"
                                    [appMath]="node.content">
                                </div>
                            </div>
                        </li>
                        <!-- <button mat-icon-button disabled></button> -->
                    </mat-nested-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild; let i = index" class="cha">
                        <li class="example-tree-container">
                            <div class="mat-tree-node">
                                <button mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'Toggle ' + node.content" style="width: 32px; height: 32px; line-height: 32px; padding-left: 3px">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 node-tree" style="white-space: pre-line" 
                                    [appMath]="node.content">   
                                </div> 
                            </div>
                            <ul class="example-tree-nested-node">
                                <div *ngIf="treeControl.isExpanded(node)">
                                    <ng-container matTreeNodeOutlet></ng-container>
                                </div>
                            </ul>
                        </li>

                    </mat-nested-tree-node>
                </mat-tree>
            </div>
            <!-- tab noi dung -->
            <div class="tree tree-tab2" *ngIf="active_tab == 'content'">
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-nested-tree-node *matTreeNodeDef="let node">
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <li class="example-tree-container">
                            <div class="mat-tree-node">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 node-tree" style="padding-left: 32px !important; white-space: pre-line" 
                                    [appMath]="node.content">
                                </div>
                            </div>
                        </li>
                        <!-- <button mat-icon-button disabled></button> -->    
                    </mat-nested-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild; let i = index">
                        <li class="example-tree-container">
                            <div class="mat-tree-node">
                                <button mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'Toggle ' + node.content" style="width: 32px; height: 32px; line-height: 32px; padding-left: 3px">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 node-tree" style="white-space: pre-line"
                                    [appMath]="node.content">
                                </div> 
                            </div>
                            <ul class="example-tree-nested-node">
                                <div *ngIf="treeControl.isExpanded(node)">
                                    <ng-container matTreeNodeOutlet></ng-container>
                                </div>
                            </ul>
                        </li>
                    </mat-nested-tree-node>
                </mat-tree>

            </div>
        </div>
    </div>
</div>
<div class="spinner" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
</div>


